import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Config} from 'ionic-angular';
import {Md5} from 'ts-md5/dist/md5';
import {Observable} from 'rxjs/Observable';
import {Api} from './api.service';

import moment from 'moment';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/delay';

@Injectable()
export class Backend {
    data: any;

    constructor(private api: Api,
                private http: Http,
                private config: Config) {
        moment.locale('hu');
    }

    getYouTubeVideoTitle(url: string): Promise<any> {
        return this.http.get(url)
            .map((res: Response) => JSON.parse(res.text()))
            .toPromise();
    }

    // Auth
    login(name: string, password: string): Observable<any> {
        return this.api.post('login', JSON.stringify({
            username: name,
            password: Md5.hashStr(password)
        }));
    }

    // Messages
    getList(segment: string, queryText = '', offset = 0, limit = 20): Promise<any> {
        if (this.config.get('radioId') === 0) return Promise.resolve(undefined);
        return this.api.get(`wall/${segment}`,
            {
                radioId: this.config.get('radioId'),
                queryText,
                limit: limit.toString(),
                offset: offset.toString()
            })
            .map((res: Response) => this.processList(res))
            .toPromise()
            .catch(this.handleError);

    }

    refreshList(segment: string, queryText = '', smsId: string): Promise<any> {

        if (this.config.get('radioId') === 0) return Promise.resolve(undefined);

        return this.api.get(`wall/refresh/${segment}`,
            {
                radioId: this.config.get('radioId'),
                smsId,
                queryText
            })
            .toPromise()
            .catch(this.handleError);
    }

    sendMessage(smsId: string, dst: string, text: string): Promise<any> {
        return this.api.post('wall/send', JSON.stringify({
            radioId: this.config.get('radioId'),
            smsId,
            dst,
            text
        }))
            .map((res: Response) => res.json())
            .toPromise()
            .catch(this.handleError);

        /*return new Promise((resolve) => {
          setTimeout(() => {
            resolve({
              http_code: 200,
              info: "OK",
              multipart: false
            });
          }, 2000);
        });*/
    }

    sendMessageDUMMY(smsId: string, dst: string, text: string): Promise<any> {
        return Observable.of(dst).delay(2000).toPromise();
    }

    markMessage(smsId: string, mark: number): Promise<any> {
        return this.api.get('wall/mark', {
            radioId: this.config.get('radioId'),
            smsId,
            mark: mark.toString()
        })
            .toPromise()
            .catch(this.handleError);
    }

    restoreMessage(smsId: string): Promise<any> {
        return this.api.get('wall/restore', {
            radioId: this.config.get('radioId'),
            smsId
        })
            .toPromise()
            .catch(this.handleError);
    }

    deleteMessage(smsId: string): Promise<any> {
        return this.api.get('wall/delete', {
            radioId: this.config.get('radioId'),
            smsId
        })
            .toPromise()
            .catch(this.handleError);
    }


    spamMessage(smsId: string): Promise<any> {
        return this.api.get('wall/spammessage', {
            radioId: this.config.get('radioId'),
            smsId
        })
            .toPromise()
            .catch(this.handleError);
    }

    exportMessages(dateStart: string, dateEnd: string, idStart = '', idEnd = ''): Promise<any> {
        return this.api.get('wall/export', {
            radioId: this.config.get('radioId'),
            dateStart: moment(dateStart).format('YYYY-MM-DD HH:mm:ss'),
            dateEnd: moment(dateEnd).format('YYYY-MM-DD HH:mm:ss'),
            idStart: idStart.charAt(0) === '#' ? idStart.substr(1) : idStart,
            idEnd: idEnd.charAt(0) === '#' ? idEnd.substr(1) : idEnd
        })
            .toPromise()
            .catch(this.handleError);
    }

    // Contacts
    getContacts(queryText = '', offset = 0, limit = 40): Promise<any> | undefined {

        if (this.config.get('radioId') === 0) return Promise.resolve(undefined);

        return this.api.get('wall/contact',
            {
                radioId: this.config.get('radioId'),
                queryText,
                limit: limit.toString(),
                offset: offset.toString()
            })
            .map((res: Response) => {
                const data = JSON.parse(res.text());
                if (data === 'NOTHING_NEW') return undefined;
                else return data;
            })
            .toPromise()
            .catch(this.handleError);
    }

    addContact(name: string, src: string): Promise<any> {
        return this.api.post('wall/contact/add', JSON.stringify({
            radioId: this.config.get('radioId'),
            name,
            src
        }))
            .toPromise()
            .catch(this.handleError);
    }

    updateContact(userId: string, name: string, src: string): Promise<any> {
        return this.api.post('wall/contact/update', JSON.stringify({
            radioId: this.config.get('radioId'),
            userId,
            name,
            src
        }))
            .toPromise()
            .catch(this.handleError);
    }

    /**
     * Update User Status
     * @param {string} userId
     * @param {number} status
     * @returns {Promise<any>}
     */
    updateContactStatus(userId: string, status: number): Promise<any> {
        return this.api.post('wall/contact/updatestatus', JSON.stringify({
            radioId: this.config.get('radioId'),
            userId,
            status
        }))
            .toPromise()
            .catch(this.handleError);
    }

    updateContactMessageStatusSpam(src: string): Promise<any> {
        return this.api.post('wall/contact/updatecontactmessagestatusspam', JSON.stringify({
            radioId: this.config.get('radioId'),
            src: src

        }))
            .toPromise()
            .catch(this.handleError);
    }


    deleteContact(contactId: string): Promise<any> {
        return this.api.get('wall/contact/delete', {
            radioId: this.config.get('radioId'),
            userId: contactId
        })
            .toPromise()
            .catch(this.handleError);
    }

    // Utilities
    private processList(res: Response): null | Array<any> {
        const data: any = JSON.parse(res.text());

        if (data === 'NOTHING_NEW') return undefined;

        const groups: Array<any> = [];
        let hour: any;
        let day: any;
        data.forEach((sms: any) => {

            // Parse text for possible YouTube links
            if (this.youtubeParser(sms.text)) {
                sms.text = sms.text.replace(
                    this.youtubeParser(sms.text),
                    `<span class="youtube-link">${this.youtubeParser(sms.text)}</span>`
                );
            }

            // Parse text for possible URL link
            if (this.urlParser(sms.text))
                sms.text = sms.text.replace(
                    this.urlParser(sms.text),
                    `<a href="${this.urlParser(sms.text)}" target="_blank">${this.urlParser(sms.text)}</a>`
                );

            if (!hour || hour !== moment(sms.timestamp).format('HH:00')) {
                hour = moment(sms.timestamp).format('HH:00');

                if (!day || day !== moment(sms.timestamp).format('MMM Do dddd')) {
                    day = moment(sms.timestamp).format('MMM Do dddd');

                    groups.push({
                        day,
                        time: hour,
                        items: []
                    });
                } else
                    groups.push({
                        day: 0,
                        time: hour,
                        items: []
                    });
            }
            groups[groups.length - 1].items.push(sms);
        });
        return groups;
    }

    private youtubeParser = (txt: string): string | false => {
        const regExp = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i;
        const match = txt.match(regExp);

        return (match && match[1].length !== 0) ? match[0] : false;
    };

    private urlParser = (txt: string): string | false => {
        const regExp = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
        const match = txt.match(regExp);

        return match ? match[0] : false;
    };

    private handleError = (error: Response | any): void => {
        console.error(error);
    }
}



// WEBPACK FOOTER //
// ./src/providers/backend.service.ts